<template>
  <global-dialog-card
    v-model="dialog"
    :max-width="500"
    :title="$t('qr_code')"
    hide-actions
  >
    <!-- QR Code Preview -->
    <v-row justify="center" no-gutters class="mt-2">
      <vue-qrcode
        :value="qrSecret"
        :options="{ width: 200 }"
        style="border: 2px solid gray"
      ></vue-qrcode>
    </v-row>

    <!-- Download Section -->
    <v-divider class="my-4"></v-divider>

    <!-- QR Export Component -->
    <qr-code-export
      :qr-code="qrSecret"
      :file-name="sanitizedRestaurantName"
      :title="restaurantName"
    />
  </global-dialog-card>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
import QrCodeExport from "./QrCodeExport.vue";

export default {
  name: "QrCodeDialog",
  components: {
    VueQrcode,
    QrCodeExport,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    qrSecret: {
      type: String,
      default: "",
    },
    restaurantName: {
      type: String,
      default: "",
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    sanitizedRestaurantName() {
      return (
        this.restaurantName
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "_")
          .replace(/_+/g, "_")
          .replace(/^_|_$/g, "") || "restaurant"
      );
    },
  },
};
</script>
